module.exports = ".no-access {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  font-size: 50px;\n  height: 100%;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  background: #003a62;\n  color: white; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/no-access/no-access.component.scss
// module id = ./src/app/shared/components/no-access/no-access.component.scss
// module chunks = main